import { RICHTEXT_DEFAULT_VALUE } from '../constants';
export const gpcAppContentReducer = (state, action) => {
    var _a;
    const { brandedNotificationConfigurationData } = action.payload;
    if ((_a = brandedNotificationConfigurationData.contentData) === null || _a === void 0 ? void 0 : _a.profileData) {
        const contentData = JSON.parse(brandedNotificationConfigurationData.contentData.profileData);
        const { gpcHeader, pbeHeader, uploadSuccessfulMessage, autoRedirectionUrl } = state.contentData;
        return Object.assign(Object.assign(Object.assign({}, state.contentData), contentData), { gpcHeader: contentData.gpcHeader || gpcHeader, pbeHeader: contentData.pbeHeader || pbeHeader, uploadSuccessfulMessage: contentData && contentData.uploadSuccessfulMessage !== RICHTEXT_DEFAULT_VALUE
                ? contentData.uploadSuccessfulMessage
                : uploadSuccessfulMessage, autoRedirectionUrl: (contentData && contentData.autoRedirectionUrl) || autoRedirectionUrl, redirectionButtonText: contentData.redirectionButtonText || '' });
    }
    return state.contentData;
};
//# sourceMappingURL=gpcAppContentReducer.js.map